import { useEffect, useCallback, useRef } from 'react';

interface MenuItem {
  id: string;
  label: string;
}

const useScrollSync = (menuItems: MenuItem[], onMenuItemClick: (contentId: string) => void) => {
  const lastActiveRef = useRef<string>('');

  const handleScroll = useCallback(() => {
    const sections = menuItems.map(item => document.getElementById(item.id)).filter(Boolean);
    const scrollPosition = window.scrollY + 100;

    for (let i = sections.length - 1; i >= 0; i--) {
      const section = sections[i];
      if (section && section.offsetTop <= scrollPosition) {
        const newActive = menuItems[i].id;
        if (lastActiveRef.current !== newActive) {
          lastActiveRef.current = newActive;
          onMenuItemClick(newActive);
        }
        break;
      }
    }
  }, [menuItems, onMenuItemClick]);

  useEffect(() => {
    let ticking = false;
    const throttledScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledScroll, { passive: true });
    return () => window.removeEventListener('scroll', throttledScroll);
  }, [handleScroll]);
};

export default useScrollSync;
